export default import.meta.ROLLUP_FILE_URL_mr6C7LrpBXve_Tb1FmWT2g